import { useEffect, useState } from "react";
import { Images, Newspaper, FileText, CalendarHeart, Tags, LayoutPanelTop, Mail, Users } from "lucide-react";
import { api } from "../../lib/api";
import { Reveal } from "../../components/Reveal";

const CARDS = [
  { key: "photos", label: "कुल फोटो", icon: Images, testid: "stat-photos" },
  { key: "blogs", label: "कुल ब्लॉग", icon: Newspaper, testid: "stat-blogs" },
  { key: "documents", label: "कुल दस्तावेज़/PDF", icon: FileText, testid: "stat-documents" },
  { key: "events", label: "कुल कार्यक्रम", icon: CalendarHeart, testid: "stat-events" },
  { key: "categories", label: "कुल श्रेणियां", icon: Tags, testid: "stat-categories" },
  { key: "banners", label: "कुल बैनर", icon: LayoutPanelTop, testid: "stat-banners" },
  { key: "messages", label: "संपर्क संदेश", icon: Mail, testid: "stat-messages" },
  { key: "volunteers", label: "स्वयंसेवक आवेदन", icon: Users, testid: "stat-volunteers" },
];

export default function DashboardHome() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => setStats({}));
  }, []);
  if (!stats) return <p className="text-ngo-ink/50 py-10 text-center">...</p>;
  return (
    <div data-testid="dashboard-stats" className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {CARDS.map((c, i) => (
        <Reveal key={c.key} i={i}>
          <div data-testid={c.testid} className="bg-white rounded-2xl border border-ngo-deep/10 p-6 hover:-translate-y-1 hover:shadow-[0_14px_36px_rgba(23,107,58,0.12)] transition-[box-shadow,transform] duration-300">
            <div className="w-11 h-11 rounded-xl bg-ngo-mint flex items-center justify-center text-ngo-deep">
              <c.icon size={20} />
            </div>
            <p className="mt-4 font-heading font-black text-3xl text-ngo-ink">{stats[c.key] ?? 0}</p>
            <p className="text-sm text-ngo-ink/60 mt-1">{c.label}</p>
          </div>
        </Reveal>
      ))}
    </div>
  );
}
